module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3@2-ba6cfdca62d1902872371d8ded2052ee.webp";